(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tj-lucky-catch"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-tj-lucky]').forEach((root) => {
      if (root.dataset.ready === 'true') return;
      root.dataset.ready = 'true';

      const cards = [...root.querySelectorAll('.tj-lucky__card')];
      const thumbs = [...root.querySelectorAll('.tj-lucky__thumb')];
      const button = root.querySelector('[data-tj-spin]');
      const status = root.querySelector('[data-tj-status]');
      if (!cards.length || !button) return;

      let active = 0;
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

      function show(index) {
        active = index;
        cards.forEach((card, cardIndex) => {
          card.hidden = cardIndex !== index;
        });
        thumbs.forEach((thumb, thumbIndex) => {
          thumb.classList.toggle('is-active', thumbIndex === index);
        });
        const title = cards[index]?.querySelector('h3')?.textContent.trim();
        if (status) status.textContent = title ? `Next pick: ${title}` : '';
      }

      show(0);

      button.addEventListener('click', () => {
        if (cards.length === 1) return;
        let next = Math.floor(Math.random() * (cards.length - 1));
        if (next >= active) next += 1;

        button.classList.remove('is-spinning');
        void button.offsetWidth;
        button.classList.add('is-spinning');

        const delay = reduceMotion.matches ? 0 : 420;
        window.setTimeout(() => {
          show(next);
          button.classList.remove('is-spinning');
        }, delay);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
